var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { startTransition, Suspense } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// Компонент загрузки для Suspense
var LoadingComponent = function () { return (_jsx("div", __assign({ style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '50px',
        fontSize: '1.2rem'
    } }, { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0431\u043B\u043E\u0433\u0430..." }))); };
// Этот компонент будет оборачивать страницу блога и обрабатывать переходы
export var BlogPageWrapper = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var location = useLocation();
    // Перехватываем все клики по ссылкам внутри компонента
    var handleClick = function (e) {
        var target = e.target;
        var anchor = target.closest('a');
        if (anchor && anchor.href && anchor.href.startsWith(window.location.origin)) {
            e.preventDefault();
            // Используем startTransition для плавного перехода
            startTransition(function () {
                navigate(anchor.href.replace(window.location.origin, ''));
            });
        }
    };
    // Добавляем глобальный слушатель для кнопки назад
    React.useEffect(function () {
        var handlePopState = function () {
            startTransition(function () {
                // Перезагружаем текущий путь
                navigate(location.pathname, { replace: true });
            });
        };
        window.addEventListener('popstate', handlePopState);
        return function () {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [location.pathname, navigate]);
    return (_jsx("div", __assign({ onClick: handleClick }, { children: _jsx(Suspense, __assign({ fallback: _jsx(LoadingComponent, {}) }, { children: children })) })));
};
export default BlogPageWrapper;
